import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import Image from 'next/image';
import styles from './listing-carousel-slide.module.scss';
interface ListingCarouselSlideProps {
  src: string;
  alt: string;
  index: number;
  isHighPriority?: boolean;
}
export default function ListingCarouselSlide(props) {
  const $ = _c(7);
  const {
    alt,
    index,
    isHighPriority,
    src
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cx(styles.embla__slide__img);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isHighPriority && index === 0;
  const t2 = isHighPriority && index === 0 ? "high" : "low";
  const t3 = isHighPriority && index === 0 ? "eager" : "lazy";
  let t4;
  if ($[1] !== alt || $[2] !== src || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = <div className={styles.embla__slide}><figure><Image className={t0} src={src} alt={alt} fill={true} sizes="372px" quality={15} priority={t1} fetchPriority={t2} loading={t3} /></figure></div>;
    $[1] = alt;
    $[2] = src;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}